/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var R = require("ramda");

var stringUtil = require("../util/string");

var Aggregators = require("./slick.dataview").Aggregators;

//-------------------------------------------
// Default implementation of the resolver factory
// accepts a string id and returns an aggregator.
// slick.grid sum aggregator example:
// https://github.com/mleibman/SlickGrid/blob/master/slick.dataview.js#L1101
function defaultFactory(id) {
    if (stringUtil.isNullOrWhitespace(id)) { throw new Error("aggregator factory id must be non-empty string."); }
    var pair = id.split(":");
    switch (pair[1].toLowerCase()) {
    case "avg":
        return new Aggregators.Avg(pair[0]);
    case "max":
        return new Aggregators.Max(pair[0]);
    case "min":
        return new Aggregators.Min(pair[0]);
    case "sum":
        return new Aggregators.Sum(pair[0]);
    default:
        throw new Error("`".concat(id, "` aggregator type is not supported."));
    }
}


//-------------------------------------------
// Accepts a factory function and returns a function
// that resolves an aggregator.
function init(factory) {
    return function aggregatorResolver(context, value) {
        var result;
        if (Array.isArray(value)) {
            var i, l = value.length, current = [];
            for (i = 0; i < l; i += 1) {
                current = current.concat(aggregatorResolver(context, value[i]));
            }
            result = current;
        } else if (R.is(Object, value) && typeof value.accumulate === "function") {
            result = [value];
        } else {
            result = [factory.call(context, value)];
        }
        return result;
    };
}


module.exports = {
    defaultFactory: init(defaultFactory),
    init: init
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/ko-grid/aggregatorFactory.js
// module id = 415
// module chunks = 49